import React from 'react';
import Http from 'helpers/http';

class BtnContainer extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            question: props.question,
        }

        this.helper = new Http;

        this.condition = props.condition;
        this.action = props.action;
    }

    componentWillReceiveProps(nextProps) {
        this.state.question = nextProps.question;
    }

    componentWillUpdate(nextProps, nextState) {
        // nextState.question = nextProps.question;
    }

    render() {
        if (this.condition && !this.condition()) return false;
        return (
            <div className={'btn-container' + ` ${this.props.containerClass || ''}`}>
              <div className={'btn question-btn' + ` ${this.props.className || ''}`} onClick={this.action}>{this.props.text}</div>
            </div>
        );
    };
}

export default BtnContainer;
